// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { CarriersGetCarriersData, CarriersGetCarriersErrors, CarriersGetCarriersResponses, CompsTableGetCompsTableData, CompsTableGetCompsTableErrors, CompsTableGetCompsTableResponses, CompsVisibilityGetCompsVisibilityData, CompsVisibilityGetCompsVisibilityErrors, CompsVisibilityGetCompsVisibilityResponses, CompsVisibilityUpdateCompsVisibilityData, CompsVisibilityUpdateCompsVisibilityErrors, CompsVisibilityUpdateCompsVisibilityResponses, ConfigurationsCreateConfigurationData, ConfigurationsCreateConfigurationErrors, ConfigurationsCreateConfigurationResponses, ConfigurationsDeleteConfigurationData, ConfigurationsDeleteConfigurationErrors, ConfigurationsDeleteConfigurationResponses, ConfigurationsGetConfigurationData, ConfigurationsGetConfigurationErrors, ConfigurationsGetConfigurationResponses, ConfigurationsGetRfpConfigurationData, ConfigurationsGetRfpConfigurationErrors, ConfigurationsGetRfpConfigurationResponses, ConfigurationsListBrokerConfigurationsData, ConfigurationsListBrokerConfigurationsErrors, ConfigurationsListBrokerConfigurationsResponses, ConfigurationsListBrokerMarketingPresentationTemplatesData, ConfigurationsListBrokerMarketingPresentationTemplatesErrors, ConfigurationsListBrokerMarketingPresentationTemplatesResponses, ConfigurationsListConfigurationsData, ConfigurationsListConfigurationsErrors, ConfigurationsListConfigurationsResponses, ConfigurationsListMarketingPresentationTemplateCatalogData, ConfigurationsListMarketingPresentationTemplateCatalogErrors, ConfigurationsListMarketingPresentationTemplateCatalogResponses, ConfigurationsPublishConfigurationData, ConfigurationsPublishConfigurationErrors, ConfigurationsPublishConfigurationResponses, ConfigurationsSetRfpConfigurationData, ConfigurationsSetRfpConfigurationErrors, ConfigurationsSetRfpConfigurationResponses, ConfigurationsSyncBrokerAssignmentsData, ConfigurationsSyncBrokerAssignmentsErrors, ConfigurationsSyncBrokerAssignmentsResponses, ConfigurationsUnpublishConfigurationData, ConfigurationsUnpublishConfigurationErrors, ConfigurationsUnpublishConfigurationResponses, ConfigurationsUpdateConfigurationData, ConfigurationsUpdateConfigurationErrors, ConfigurationsUpdateConfigurationResponses, ResponsesTableGetResponsesTableData, ResponsesTableGetResponsesTableErrors, ResponsesTableGetResponsesTableResponses, ResponsesTableUpdateResponsesTableCellData, ResponsesTableUpdateResponsesTableCellErrors, ResponsesTableUpdateResponsesTableCellResponses, ResponsesVisibilityGetResponsesVisibilityData, ResponsesVisibilityGetResponsesVisibilityErrors, ResponsesVisibilityGetResponsesVisibilityResponses, ResponsesVisibilityUpdateResponsesVisibilityData, ResponsesVisibilityUpdateResponsesVisibilityErrors, ResponsesVisibilityUpdateResponsesVisibilityResponses, RumiGetLatestRumiRunData, RumiGetLatestRumiRunErrors, RumiGetLatestRumiRunResponses, RumiStartRumiRunData, RumiStartRumiRunErrors, RumiStartRumiRunResponses } from './types.gen';
import { zCarriersGetCarriersResponse, zCompsTableGetCompsTableHeaders, zCompsTableGetCompsTablePath, zCompsTableGetCompsTableResponse, zCompsVisibilityGetCompsVisibilityPath, zCompsVisibilityGetCompsVisibilityResponse, zCompsVisibilityUpdateCompsVisibilityBody, zCompsVisibilityUpdateCompsVisibilityPath, zCompsVisibilityUpdateCompsVisibilityResponse, zConfigurationsCreateConfigurationBody, zConfigurationsCreateConfigurationResponse, zConfigurationsDeleteConfigurationPath, zConfigurationsDeleteConfigurationResponse, zConfigurationsGetConfigurationPath, zConfigurationsGetConfigurationResponse, zConfigurationsGetRfpConfigurationPath, zConfigurationsGetRfpConfigurationResponse, zConfigurationsListBrokerConfigurationsPath, zConfigurationsListBrokerConfigurationsResponse, zConfigurationsListBrokerMarketingPresentationTemplatesPath, zConfigurationsListBrokerMarketingPresentationTemplatesResponse, zConfigurationsListConfigurationsResponse2, zConfigurationsListMarketingPresentationTemplateCatalogResponse, zConfigurationsPublishConfigurationPath, zConfigurationsPublishConfigurationResponse, zConfigurationsSetRfpConfigurationBody, zConfigurationsSetRfpConfigurationPath, zConfigurationsSetRfpConfigurationResponse, zConfigurationsSyncBrokerAssignmentsBody, zConfigurationsSyncBrokerAssignmentsPath, zConfigurationsSyncBrokerAssignmentsResponse, zConfigurationsUnpublishConfigurationPath, zConfigurationsUnpublishConfigurationResponse, zConfigurationsUpdateConfigurationBody, zConfigurationsUpdateConfigurationPath, zConfigurationsUpdateConfigurationResponse, zResponsesTableGetResponsesTableHeaders, zResponsesTableGetResponsesTablePath, zResponsesTableGetResponsesTableResponse, zResponsesTableUpdateResponsesTableCellBody, zResponsesTableUpdateResponsesTableCellPath, zResponsesTableUpdateResponsesTableCellResponse, zResponsesVisibilityGetResponsesVisibilityPath, zResponsesVisibilityGetResponsesVisibilityResponse, zResponsesVisibilityUpdateResponsesVisibilityBody, zResponsesVisibilityUpdateResponsesVisibilityPath, zResponsesVisibilityUpdateResponsesVisibilityResponse, zRumiGetLatestRumiRunPath, zRumiGetLatestRumiRunResponse, zRumiStartRumiRunPath, zRumiStartRumiRunResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get the Responses table for an RFP
 *
 * Returns the carriers × coverages matrix that powers the
 * Responses sub-tab.
 *
 * The response contains three top-level collections:
 * - `carriers` — one entry per carrier invited to the RFP, in
 * display sequence.
 * - `coverages` — one entry per coverage requested on the RFP,
 * in display sequence.
 * - `cells` — a **sparse** list of `(carrierId, planGroupId)`
 * pairs with the latest proposal data for that pair.
 *
 * Cells are sparse: any `(carrierId, planGroupId)` pair that
 * is *not* present in `cells[]` should be rendered as
 * `pending` by the client. This keeps payload size small for
 * early-stage RFPs where most carriers have not yet responded.
 *
 * Returns `200` with empty `carriers`/`coverages` arrays only
 * when the RFP exists but has no invited carriers and no
 * requested coverages. Otherwise the populated arrays describe
 * the grid the FE should render.
 *
 */
export const responsesTableGetResponsesTable = <ThrowOnError extends boolean = false>(options: Options<ResponsesTableGetResponsesTableData, ThrowOnError>) => (options.client ?? client).get<ResponsesTableGetResponsesTableResponses, ResponsesTableGetResponsesTableErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zResponsesTableGetResponsesTableHeaders.optional(),
        path: zResponsesTableGetResponsesTablePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zResponsesTableGetResponsesTableResponse.parseAsync(data),
    url: '/rfps/{id}/responses-table',
    ...options
});

/**
 * Set the manual status for a single carrier × plan-group cell
 *
 * Allows an analyst to manually override the status displayed for a
 * specific `(carrierId, planGroupId)` cell. The `manualStatus` value
 * takes precedence over the status computed from the underlying
 * proposal data.
 *
 */
export const responsesTableUpdateResponsesTableCell = <ThrowOnError extends boolean = false>(options: Options<ResponsesTableUpdateResponsesTableCellData, ThrowOnError>) => (options.client ?? client).put<ResponsesTableUpdateResponsesTableCellResponses, ResponsesTableUpdateResponsesTableCellErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zResponsesTableUpdateResponsesTableCellBody,
        path: zResponsesTableUpdateResponsesTableCellPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zResponsesTableUpdateResponsesTableCellResponse.parseAsync(data),
    url: '/rfps/{id}/responses-table',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the shared hidden carriers and coverages for an RFP
 *
 * Returns the shared, per-RFP set of hidden carrier ids and hidden
 * plan-group ids. Returns `200` with empty arrays when no visibility
 * has been persisted yet.
 *
 */
export const responsesVisibilityGetResponsesVisibility = <ThrowOnError extends boolean = false>(options: Options<ResponsesVisibilityGetResponsesVisibilityData, ThrowOnError>) => (options.client ?? client).get<ResponsesVisibilityGetResponsesVisibilityResponses, ResponsesVisibilityGetResponsesVisibilityErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zResponsesVisibilityGetResponsesVisibilityPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zResponsesVisibilityGetResponsesVisibilityResponse.parseAsync(data),
    url: '/rfps/{id}/responses-visibility',
    ...options
});

/**
 * Replace the shared hidden carriers and coverages for an RFP
 *
 * Upserts the shared, per-RFP hidden set. Each field, when present,
 * replaces the stored list wholesale; send an empty array to clear a
 * list. Omitted fields are left unchanged.
 *
 */
export const responsesVisibilityUpdateResponsesVisibility = <ThrowOnError extends boolean = false>(options: Options<ResponsesVisibilityUpdateResponsesVisibilityData, ThrowOnError>) => (options.client ?? client).put<ResponsesVisibilityUpdateResponsesVisibilityResponses, ResponsesVisibilityUpdateResponsesVisibilityErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zResponsesVisibilityUpdateResponsesVisibilityBody,
        path: zResponsesVisibilityUpdateResponsesVisibilityPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zResponsesVisibilityUpdateResponsesVisibilityResponse.parseAsync(data),
    url: '/rfps/{id}/responses-visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the Comps table for an RFP
 *
 * Returns the coverages × commission-columns matrix that
 * powers the Comps sub-tab of the *Present* tab.
 *
 * The response contains the following top-level collections:
 * - `coverages` — one entry per plan-group row: one per RFP
 * benefit plan group, plus one per off-script quoted proposal
 * plan group (rows).
 * - `carriers` — one entry per carrier the RFP was sent to,
 * in display sequence (carrier columns).
 * - `requestedColumn` — the always-present *Requested
 * Commission* column with one cell per coverage
 * (FR-PCP-01-04).
 * - `incumbentColumn` — present only when the RFP has an
 * incumbent carrier and incumbent commission data is
 * available; otherwise omitted.
 * - `cells` — **sparse** list of `(carrierId, planGroupId)`
 * carrier commission cells. Missing cells
 * should be rendered as `pending`.
 * - `notesRow` — the always-present bottom *Notes* row; its
 * internal `cells` array is sparse and may be empty.
 * - `subsidyRows` — optional fixed set of subsidy / credit
 * rows; absent or empty when not in use.
 *
 * Cells are sparse: any `(carrierId, planGroupId)` pair that
 * is *not* present in `cells[]` should be rendered as
 * `pending` by the client. This keeps payload size small for
 * early-stage RFPs where most carriers have not yet responded.
 *
 * Returns `200` with empty `coverages`/`carriers` arrays
 * only when the RFP exists but has no requested coverages
 * and no invited carriers. Otherwise the populated arrays
 * describe the grid the FE should render.
 *
 */
export const compsTableGetCompsTable = <ThrowOnError extends boolean = false>(options: Options<CompsTableGetCompsTableData, ThrowOnError>) => (options.client ?? client).get<CompsTableGetCompsTableResponses, CompsTableGetCompsTableErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zCompsTableGetCompsTableHeaders.optional(),
        path: zCompsTableGetCompsTablePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCompsTableGetCompsTableResponse.parseAsync(data),
    url: '/rfps/{id}/comps-table',
    ...options
});

/**
 * Get the shared hidden rows and columns for an RFP
 *
 * Returns the shared, per-RFP set of hidden row-group ids and hidden
 * column ids. Returns `200` with `configured: false` and empty arrays
 * when no visibility has been persisted yet.
 *
 */
export const compsVisibilityGetCompsVisibility = <ThrowOnError extends boolean = false>(options: Options<CompsVisibilityGetCompsVisibilityData, ThrowOnError>) => (options.client ?? client).get<CompsVisibilityGetCompsVisibilityResponses, CompsVisibilityGetCompsVisibilityErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zCompsVisibilityGetCompsVisibilityPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCompsVisibilityGetCompsVisibilityResponse.parseAsync(data),
    url: '/rfps/{id}/comps-visibility',
    ...options
});

/**
 * Replace the shared hidden rows and columns for an RFP
 *
 * Upserts the shared, per-RFP hidden set. Each field, when present,
 * replaces the stored value wholesale; send an empty array to clear a
 * list. Omitted fields are left unchanged.
 *
 */
export const compsVisibilityUpdateCompsVisibility = <ThrowOnError extends boolean = false>(options: Options<CompsVisibilityUpdateCompsVisibilityData, ThrowOnError>) => (options.client ?? client).put<CompsVisibilityUpdateCompsVisibilityResponses, CompsVisibilityUpdateCompsVisibilityErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCompsVisibilityUpdateCompsVisibilityBody,
        path: zCompsVisibilityUpdateCompsVisibilityPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCompsVisibilityUpdateCompsVisibilityResponse.parseAsync(data),
    url: '/rfps/{id}/comps-visibility',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all carriers
 *
 * Returns every carrier from carriertracker, each with its stable
 * `shareIdentifier` (`id`) and display `name`. The list is unfiltered
 * and not RFP-scoped.
 *
 */
export const carriersGetCarriers = <ThrowOnError extends boolean = false>(options?: Options<CarriersGetCarriersData, ThrowOnError>) => (options?.client ?? client).get<CarriersGetCarriersResponses, CarriersGetCarriersErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCarriersGetCarriersResponse.parseAsync(data),
    url: '/carriers',
    ...options
});

/**
 * List configurations
 */
export const configurationsListConfigurations = <ThrowOnError extends boolean = false>(options?: Options<ConfigurationsListConfigurationsData, ThrowOnError>) => (options?.client ?? client).get<ConfigurationsListConfigurationsResponses, ConfigurationsListConfigurationsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsListConfigurationsResponse2.parseAsync(data),
    url: '/configurations',
    ...options
});

/**
 * Create a configuration
 */
export const configurationsCreateConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsCreateConfigurationData, ThrowOnError>) => (options.client ?? client).post<ConfigurationsCreateConfigurationResponses, ConfigurationsCreateConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zConfigurationsCreateConfigurationBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsCreateConfigurationResponse.parseAsync(data),
    url: '/configurations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a configuration
 */
export const configurationsDeleteConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsDeleteConfigurationData, ThrowOnError>) => (options.client ?? client).delete<ConfigurationsDeleteConfigurationResponses, ConfigurationsDeleteConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsDeleteConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zConfigurationsDeleteConfigurationResponse.parseAsync(data),
    url: '/configurations/{id}',
    ...options
});

/**
 * Get a configuration
 */
export const configurationsGetConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsGetConfigurationData, ThrowOnError>) => (options.client ?? client).get<ConfigurationsGetConfigurationResponses, ConfigurationsGetConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsGetConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsGetConfigurationResponse.parseAsync(data),
    url: '/configurations/{id}',
    ...options
});

/**
 * Update a configuration
 *
 * Update a configuration's name and/or nested configuration payload
 * (field settings, the dollar-difference toggle, and marketing-presentation
 * styling). Invalid style colors are dropped and reported in `warnings`.
 *
 */
export const configurationsUpdateConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsUpdateConfigurationData, ThrowOnError>) => (options.client ?? client).patch<ConfigurationsUpdateConfigurationResponses, ConfigurationsUpdateConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zConfigurationsUpdateConfigurationBody,
        path: zConfigurationsUpdateConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsUpdateConfigurationResponse.parseAsync(data),
    url: '/configurations/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish a configuration
 */
export const configurationsPublishConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsPublishConfigurationData, ThrowOnError>) => (options.client ?? client).post<ConfigurationsPublishConfigurationResponses, ConfigurationsPublishConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsPublishConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsPublishConfigurationResponse.parseAsync(data),
    url: '/configurations/{id}/publish',
    ...options
});

/**
 * Unpublish a configuration
 */
export const configurationsUnpublishConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsUnpublishConfigurationData, ThrowOnError>) => (options.client ?? client).post<ConfigurationsUnpublishConfigurationResponses, ConfigurationsUnpublishConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsUnpublishConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsUnpublishConfigurationResponse.parseAsync(data),
    url: '/configurations/{id}/unpublish',
    ...options
});

/**
 * List every available marketing-presentation template
 *
 * The catalog of template files Chameleon can render with, read from its
 * flat template folder. Used by admins assigning templates to a
 * configuration; which templates a given broker may use is configuration
 * data, not folder layout.
 *
 */
export const configurationsListMarketingPresentationTemplateCatalog = <ThrowOnError extends boolean = false>(options?: Options<ConfigurationsListMarketingPresentationTemplateCatalogData, ThrowOnError>) => (options?.client ?? client).get<ConfigurationsListMarketingPresentationTemplateCatalogResponses, ConfigurationsListMarketingPresentationTemplateCatalogErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsListMarketingPresentationTemplateCatalogResponse.parseAsync(data),
    url: '/marketing-presentation-templates',
    ...options
});

/**
 * Get the configuration an RFP is spread against
 *
 * Resolves the MP configuration for this RFP: the analyst's selection when
 * there is one, the published default otherwise. Always 200 — `source` says
 * which applied, and the full configuration travels with it so the pages can
 * render field settings without a second request.
 *
 */
export const configurationsGetRfpConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsGetRfpConfigurationData, ThrowOnError>) => (options.client ?? client).get<ConfigurationsGetRfpConfigurationResponses, ConfigurationsGetRfpConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsGetRfpConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsGetRfpConfigurationResponse.parseAsync(data),
    url: '/rfps/{rfpId}/configuration',
    ...options
});

/**
 * Select the configuration an RFP is spread against
 */
export const configurationsSetRfpConfiguration = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsSetRfpConfigurationData, ThrowOnError>) => (options.client ?? client).put<ConfigurationsSetRfpConfigurationResponses, ConfigurationsSetRfpConfigurationErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zConfigurationsSetRfpConfigurationBody,
        path: zConfigurationsSetRfpConfigurationPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsSetRfpConfigurationResponse.parseAsync(data),
    url: '/rfps/{rfpId}/configuration',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the configurations a broker's RFPs may be spread against
 *
 * Every published configuration assigned to the broker, falling back to the
 * published default when it has none of its own. This is what the analyst's
 * configuration picker offers.
 *
 */
export const configurationsListBrokerConfigurations = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsListBrokerConfigurationsData, ThrowOnError>) => (options.client ?? client).get<ConfigurationsListBrokerConfigurationsResponses, ConfigurationsListBrokerConfigurationsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsListBrokerConfigurationsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsListBrokerConfigurationsResponse.parseAsync(data),
    url: '/brokers/{brokerId}/configurations',
    ...options
});

/**
 * List the templates a broker may export with
 *
 * Templates from the broker's active configuration — the published
 * configuration assigned to the broker, falling back to the published
 * default configuration. `templates` is empty only when no default
 * configuration is published.
 *
 */
export const configurationsListBrokerMarketingPresentationTemplates = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsListBrokerMarketingPresentationTemplatesData, ThrowOnError>) => (options.client ?? client).get<ConfigurationsListBrokerMarketingPresentationTemplatesResponses, ConfigurationsListBrokerMarketingPresentationTemplatesErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zConfigurationsListBrokerMarketingPresentationTemplatesPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zConfigurationsListBrokerMarketingPresentationTemplatesResponse.parseAsync(data),
    url: '/brokers/{brokerId}/marketing-presentation-templates',
    ...options
});

/**
 * Sync broker assignments
 *
 * Atomically replaces all broker assignments for a configuration.
 */
export const configurationsSyncBrokerAssignments = <ThrowOnError extends boolean = false>(options: Options<ConfigurationsSyncBrokerAssignmentsData, ThrowOnError>) => (options.client ?? client).put<ConfigurationsSyncBrokerAssignmentsResponses, ConfigurationsSyncBrokerAssignmentsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zConfigurationsSyncBrokerAssignmentsBody,
        path: zConfigurationsSyncBrokerAssignmentsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zConfigurationsSyncBrokerAssignmentsResponse.parseAsync(data),
    url: '/configurations/{id}/assignments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the RFP's latest Rumi Run
 *
 * Returns the RFP's most recent Run, open or ended, or `run: null` when
 * the RFP has never had one. While a Run is open, `outcome`, `endedAt`,
 * `rumiStatus`, `runCost`, and `results` are null. A Run that has just
 * started may not have a `seq` yet.
 *
 * For an ended Run, `results` holds what Rumi recorded, grouped by what
 * each statement is about, and every coverage the RFP has in btx with
 * each of its product and policy-period rows, their plan counts and
 * completion statuses. A Run that recorded nothing has empty groups,
 * not null ones. `results.counts` holds the numbers the Launchpad's
 * summary tiles show, counted from the RFP as it stands now.
 *
 */
export const rumiGetLatestRumiRun = <ThrowOnError extends boolean = false>(options: Options<RumiGetLatestRumiRunData, ThrowOnError>) => (options.client ?? client).get<RumiGetLatestRumiRunResponses, RumiGetLatestRumiRunErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRumiGetLatestRumiRunPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRumiGetLatestRumiRunResponse.parseAsync(data),
    url: '/rfps/{id}/rumi',
    ...options
});

/**
 * Start a Rumi Run of the RFP
 *
 * Starts a Run and answers with it. `run` is null in the rare case
 * that the Run started but could not be read back; the next read of
 * `GET /rfps/{id}/rumi` returns it. Only one Run of an RFP may be open.
 *
 */
export const rumiStartRumiRun = <ThrowOnError extends boolean = false>(options: Options<RumiStartRumiRunData, ThrowOnError>) => (options.client ?? client).post<RumiStartRumiRunResponses, RumiStartRumiRunErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRumiStartRumiRunPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRumiStartRumiRunResponse.parseAsync(data),
    url: '/rfps/{id}/rumi/runs',
    ...options
});
